import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import DynamicIcon from '../DynamicIcon/DynamicIcon';
import { socialMediaOptions } from '../IconPicker/Options';
import './Links.css';

interface LinkItem {
    _id?: string;
    icon_id?: number | null;
    icon_name?: string;
    social_name?: string;
}

interface ButtonTheme {
    text?: string;
    background?: string;
    border?: { color?: string; width?: string; radius?: string };
    shadow?: { enabled?: boolean; color?: string };
}

interface LinksProps {
    links: LinkItem[];
    theme: { button?: ButtonTheme } & Record<string, any>;
    origin?: string;
    className?: string;
}

const Links = ({ links, theme, origin, className }: LinksProps) => {
    const styles = {
        textLink: {
            color: theme?.button?.text,
        },
        buttonColor: {
            backgroundColor: theme?.button?.background,
            border: theme?.button?.border?.color && theme?.button?.border?.width
                ? `${theme.button.border.width} solid ${theme.button.border.color}`
                : undefined,
            borderRadius: theme?.button?.border?.radius || '2rem',
            boxShadow: theme?.button?.shadow?.enabled && theme?.button?.shadow?.color
                ? `0 2px 8px ${theme.button.shadow.color}`
                : undefined,
        },
    };

    return (
        <Stack
            className={className}
            direction="column"
            justifyContent="space-around"
            alignItems="stretch"
            spacing={2}
        >
            {links.map((link, index) => {
                const mediaOption = socialMediaOptions.find(item => item.id === link.icon_id || item.label === link.social_name);
                return (
                    <Button
                        key={`button-${index}-key`}
                        target="_blank"
                        style={styles.buttonColor}
                        className={`button-link ${origin === 'preview' ? 'disabled-link' : ''}`}
                        variant='contained'
                        size="large"
                        startIcon={
                            <DynamicIcon
                                isGlobal={!mediaOption}
                                idIcon={link.icon_id ?? undefined}
                                name={link.icon_name}
                                color={styles.textLink.color}
                            />
                        }
                        href={`${process.env.REACT_APP_API_BASE_URL}/l/${link._id}`}
                        rel="noopener noreferrer"
                    >
                        <span key={`span-${index}-key`} id={`${index}-link`} style={styles.textLink} className={'text-link'}>
                            {mediaOption ? mediaOption.label : 'Social media'}
                        </span>
                    </Button>
                );
            })}
        </Stack>
    );
};

export default Links;
